import { supportsCookies } from "../utils/supportsCookies.js";
/**
 * Does the current browser support cookies?
 */ const preDecisionGatewaySupportsCookies = async (param)=>{
    let { supportsCookiesName } = param;
    return supportsCookies(supportsCookiesName) ? false : "essentials";
};
export { preDecisionGatewaySupportsCookies };
